
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import Testimonials from "@/components/Testimonials";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import PageHead from "@/components/PageHead";

const Index = () => {
  return (
    <div className="min-h-screen bg-white">
      <PageHead title="Home" description="Your all-in-one platform for international opportunities, travel, and education." />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
